import { cloneDeep } from 'lodash';

import {
  SET_BUYERS,
  SET_WIDGET_TITLE,
  SET_USER_VISIBLE_COLUMNS,
  SET_BUYER_REFERENCES,
  SET_CHECK_REFERENCES_TEXT,
  SET_BUYER,
  SET_INVITES_FOR_BUYER,
  SET_SHOW_NEW_BUYER_INVITES
} from './mutationTypes';

import {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError
} from '@/store/helpers';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_BUYERS](state, buyers) {
    state.buyers = buyers;
  },
  [SET_WIDGET_TITLE](state, title) {
    state.widget.title = title;
  },
  [SET_USER_VISIBLE_COLUMNS](state, userVisibleColumns) {
    state.userVisibleColumns = userVisibleColumns;
  },
  [SET_BUYER_REFERENCES](state, buyerReferences) {
    state.buyerReferences = buyerReferences;
  },
  [SET_CHECK_REFERENCES_TEXT](state, checkReferencesText) {
    state.checkReferencesText = checkReferencesText;
  },
  [SET_BUYER](state, { index, buyer }) {
    const arrayToUpdate = cloneDeep(state.buyers);
    arrayToUpdate[index] = buyer;
    state.buyers = arrayToUpdate;
  },
  [SET_INVITES_FOR_BUYER](state, { buyer }) {
    state.invitesForBuyer = buyer;
  },
  [SET_SHOW_NEW_BUYER_INVITES](state, { showNewBuyerInvites }) {
    state.showNewBuyerInvites = showNewBuyerInvites;
  }
};
